module.exports = __webpack_public_path__ + "static/media/1012218.788f3adb.png";